<label class="switch">
    <input type="checkbox" [(ngModel)]="params.value" (click)="onToggle($event)" />
    <span class="slider"></span>
</label>